import { render, staticRenderFns } from "./exportDataSimple.vue?vue&type=template&id=7dbb9914&"
import script from "./exportDataSimple.vue?vue&type=script&lang=js&"
export * from "./exportDataSimple.vue?vue&type=script&lang=js&"
import style0 from "./exportDataSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports